import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';

export default function AdminPageShell({ title, subtitle, children }) {
  return (
    <Card style={{ marginTop: 10 }}>
      <Card.Header
        className="text-center"
        style={{ backgroundColor: '#008080', color: 'white' }}
      >
        <h4 style={{ fontWeight: 'bold', marginBottom: subtitle ? 4 : 0 }}>
          {title}
        </h4>
        {subtitle && <small>{subtitle}</small>}
      </Card.Header>
      <Card.Body style={{ padding: '15px' }}>{children}</Card.Body>
    </Card>
  );
}

AdminPageShell.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  children: PropTypes.node.isRequired,
};

AdminPageShell.defaultProps = {
  subtitle: '',
};
